import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createApp } from "../api";
import AppForm, { AppFormData } from "../components/AppForm";
import PageHeader from "../components/PageHeader";
import { useToast } from "../components/Toast";
import { usePageTitle } from "../hooks/usePageTitle";

export default function NewAppPage() {
  usePageTitle("New App");
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [formData, setFormData] = useState<AppFormData>({
    name: "",
    description: "",
    shopifyDashboardUrl: "",
    clientId: "",
    clientSecret: "",
    scopes: "",
  });

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { description, shopifyDashboardUrl, ...rest } = formData;
      const app = await createApp({
        ...rest,
        ...(description ? { description } : {}),
        ...(shopifyDashboardUrl ? { shopifyDashboardUrl } : {}),
      });
      addToast(`App "${app.name}" created successfully`, "success");
      navigate(`/apps/${app.id}`);
    } catch (err) {
      // Show error inline in form, not as toast (avoid duplicate)
      setError(err instanceof Error ? err.message : "Failed to create app");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <PageHeader>
        <PageHeader.Breadcrumb to="/apps" />
        <PageHeader.Title>Register New App</PageHeader.Title>
      </PageHeader>

      <AppForm
        formData={formData}
        onChange={setFormData}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
        mode="create"
        submitLabel="Register App"
        cancelHref="/apps"
      />
    </div>
  );
}
